module.exports = __webpack_public_path__ + "img/servicesbg.1973776b.png";